import Chip from "@mui/material/Chip";
import React from "react";

export const TodoTag = ({ children }: { children: React.ReactNode }) => {
	return <Chip size="small" label={children} />;
};
